import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b7aa61a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_draft_order_overview_add_sku",
  ref: "draftOrderOverviewAddSkuRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-600px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header px-9",
  id: "kt_modal_draft_order_overview_add_sku_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-7" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group mb-7" }
const _hoisted_17 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-7" }
const _hoisted_20 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_21 = { class: "d-flex" }
const _hoisted_22 = {
  class: "btn btn-primary w-100 mw-45px h-45px p-0 border-radius-left",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_qrcode_scanner_1"
}
const _hoisted_23 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = { class: "form-group mb-7" }
const _hoisted_26 = { class: "svg-icon svg-icon-5tx svg-icon-primary" }
const _hoisted_27 = { class: "el-upload__text" }
const _hoisted_28 = { class: "thumbnail-item" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "el-upload-list__item-actions" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group mb-7" }
const _hoisted_37 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group mb-7" }
const _hoisted_40 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_41 = { class: "col-md-12" }
const _hoisted_42 = { class: "form-group mb-7" }
const _hoisted_43 = {
  key: 0,
  class: "fs-6 fw-bold mb-2"
}
const _hoisted_44 = {
  key: 1,
  class: "fs-6 fw-bold mb-2"
}
const _hoisted_45 = { class: "col-md-12" }
const _hoisted_46 = { class: "form-group mb-7" }
const _hoisted_47 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_48 = { class: "col-md-12" }
const _hoisted_49 = { class: "form-group mb-7" }
const _hoisted_50 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_51 = { class: "modal-footer justify-content-end max-sm-justify-content-center py-5 px-9" }
const _hoisted_52 = { class: "d-flex gap-3 justify-content-end max-sm-justify-content-center" }
const _hoisted_53 = { class: "svg-icon svg-icon-3" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_56 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_qrcode_scanner = _resolveComponent("qrcode-scanner")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("salesOrderOverview.newSalesOrderAddItem")), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary text-nowrap mb-7",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_sales_order_add_product_item",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showProductModal && _ctx.showProductModal(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrderOverview.newSalesOrderFindProducts")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("order.brand")), 1),
                      _createVNode(_component_el_form_item, { prop: "brand_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            ref: "selectBrand",
                            onFocus: _ctx.cancelReadonly,
                            "onHook:mounted": _ctx.cancelReadonly,
                            onVisibleChange: _ctx.cancelReadonly,
                            teleported: false,
                            modelValue: _ctx.formData.brand_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                            filterable: "",
                            clearable: "",
                            "remote-show-suffix": "",
                            remote: "",
                            "remote-method": _ctx.searchBrandSourceItems,
                            loading: _ctx.options.brandLoading,
                            placeholder: _ctx.t('common.plsSelect'),
                            onChange: _ctx.brandChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.brand, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("order.productName")), 1),
                      _createVNode(_component_el_form_item, { prop: "name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                            modelModifiers: { trim: true },
                            type: "text",
                            clearable: "",
                            placeholder: _ctx.t('common.plsEnter')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("order.articleNo")), 1),
                      _createVNode(_component_el_form_item, { prop: "brand_article_no" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_el_input, {
                              class: "flex-1",
                              modelValue: _ctx.formData.brand_article_no,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.brand_article_no) = $event)),
                              modelModifiers: { trim: true },
                              type: "text",
                              clearable: "",
                              placeholder: _ctx.t('common.plsEnter')
                            }, null, 8, ["modelValue", "placeholder"]),
                            _createVNode(_component_window_resize, null, {
                              sm: _withCtx(() => [
                                _createElementVNode("button", _hoisted_22, [
                                  _createElementVNode("span", _hoisted_23, [
                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["fs-6 fw-bold mb-2", {
                      required: _ctx.form.config_id == '2',
                    }])
                      }, _toDisplayString(_ctx.t("common.images")), 3),
                      _createVNode(_component_el_form_item, { prop: "file_upload_record_id" }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                            ref: "uploadRef",
                            class: _normalizeClass(["multiple-drag-upload bg-light-primary rounded border-primary border border-dashed", { hasfile: _ctx.fileList.length > 0 }]),
                            drag: "",
                            multiple: "",
                            "file-list": _ctx.fileList,
                            limit: 1,
                            "auto-upload": false,
                            "show-file-list": true,
                            accept: ".jpg,.jpeg,.png",
                            headers: _ctx.uploadHeaders,
                            "on-change": _ctx.onUploadChange,
                            "on-error": _ctx.onUploadError,
                            "on-exceed": _ctx.onUploadExceed
                          }, {
                            file: _withCtx(({ file }) => [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("img", {
                                  class: "el-upload-list__item-thumbnail",
                                  src: file.url,
                                  alt: ""
                                }, null, 8, _hoisted_29),
                                _createElementVNode("span", _hoisted_30, [
                                  _createElementVNode("span", {
                                    class: "el-upload-list__item-preview",
                                    onClick: ($event: any) => (_ctx.handlePreview(file))
                                  }, [
                                    _createElementVNode("span", _hoisted_32, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen004.svg" })
                                    ])
                                  ], 8, _hoisted_31),
                                  _createElementVNode("span", {
                                    class: "el-upload-list__item-delete",
                                    onClick: ($event: any) => (_ctx.handleRemove(file))
                                  }, [
                                    _createElementVNode("span", _hoisted_34, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr015.svg" })
                                    ])
                                  ], 8, _hoisted_33)
                                ])
                              ])
                            ]),
                            tip: _withCtx(() => []),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_26, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil022.svg" })
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createTextVNode(_toDisplayString(_ctx.t("common.uploadDrop")) + " ", 1),
                                _createElementVNode("em", null, _toDisplayString(_ctx.t("common.uploadClick")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["class", "file-list", "headers", "on-change", "on-error", "on-exceed"])), [
                            [_directive_loading, _ctx.uploadLoading]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("order.price")), 1),
                      _createVNode(_component_el_form_item, { prop: "base_price" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            class: "w-100 text-start",
                            modelValue: _ctx.formData.base_price,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.base_price) = $event)),
                            precision: 2,
                            step: 1,
                            min: 0.01,
                            controls: false
                          }, null, 8, ["modelValue", "min"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("order.color")), 1),
                      _createVNode(_component_el_form_item, { prop: "color_label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.color_label,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.color_label) = $event)),
                            type: "text",
                            clearable: "",
                            placeholder: _ctx.t('common.plsEnter')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      (
                      _ctx.form.config_id == '12' &&
                      _ctx.form.order_tagging == 'mma_campaign'
                    )
                        ? (_openBlock(), _createElementBlock("label", _hoisted_43, [
                            _createVNode(_component_el_form_item, { prop: "sizeType" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio_group, {
                                  class: "text-sm",
                                  modelValue: _ctx.formData.sizeType,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.sizeType) = $event)),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio, { label: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t("order.size")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_radio, { label: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t("order.rangeSize")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("label", _hoisted_44, _toDisplayString(_ctx.t("order.size")), 1)),
                      _createVNode(_component_el_form_item, { prop: "size_label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.size_label,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.size_label) = $event)),
                            type: "text",
                            clearable: "",
                            placeholder: _ctx.t('common.plsEnter')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.t("salesOrderOverview.addSkuNote")), 1),
                      _createVNode(_component_el_form_item, { prop: "remark" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.remark,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.remark) = $event)),
                            type: "textarea",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("order.sourceLink")), 1),
                      _createVNode(_component_el_form_item, { prop: "source_link" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.source_link,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.source_link) = $event)),
                            type: "textarea",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_53, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.stepcancel")), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-primary",
                    disabled: _ctx.isDisabledSubmit || _ctx.loading,
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                  }, [
                    _withDirectives(_createElementVNode("span", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1),
                      _hoisted_55
                    ], 512), [
                      [_vShow, _ctx.loading]
                    ]),
                    _withDirectives(_createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_56, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.addProducts")), 1)
                    ], 512), [
                      [_vShow, !_ctx.loading]
                    ])
                  ], 8, _hoisted_54)
                ])
              ])
            ])
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_qrcode_scanner, {
      modalReader: "modal_qrcode_scanner_1",
      reader: "qr-code-full-region-1",
      onUpdateList: _ctx.scanResult
    }, null, 8, ["onUpdateList"])
  ], 64))
}